import { http } from '../../../utils'
import { AxiosResponse } from 'axios'

export const ActionTypes = {
  GET_BILLS_PAYMENT_CHART_DATA: 'GET_BILLS_PAYMENT_CHART_DATA',
}

export const getBillsPaymentChartData = (startDate?: string, endDate?: string) => {
  let url = '/charts/pvt/payment_vs_invoices'
  if (startDate && endDate) {
    url = `/charts/pvt/payment_vs_invoices?start_date=${startDate}&end_date=${endDate}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export const getBillsPaymentChartDataAction = (startDate?: string, endDate?: string) => ({
  type: ActionTypes.GET_BILLS_PAYMENT_CHART_DATA,
  promise: getBillsPaymentChartData(startDate, endDate),
})
